<template>
  <v-dialog v-model="dialogVisible" class="white" max-width="400" persistent>
    <v-card class="ma-0 white">
      <v-card-text class="pt-4">
        <p class="ma-0 pa-0">
          <span class="text-h5" v-if="caption">{{ caption }}</span
          ><br v-if="caption" />
          <span class="text-h4 input-title primary--text">{{ title }}</span>
        </p>
        <p class="mt-4 pa-0">
          {{ message }}
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancelClick">
          {{ cancel }}
        </v-btn>
        <v-btn color="primary" text @click="onOkClick">
          {{ ok }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogConfirm',
  components: {},
  props: ['title', 'caption', 'message', 'ok', 'cancel'],
  data: () => ({
    dialogVisible: false,
    resolve: undefined,
  }),
  computed: {},
  watch: {},
  mounted() {
    if (this.type === 'side_channel') this.angle = 180;
  },
  methods: {
    async show() {
      this.dialogVisible = true;

      let promise = new Promise(res => {
        this.resolve = res;
      });

      return await promise;
    },
    onCancelClick() {
      if (this.resolve) this.resolve(false);
      this.dialogVisible = false;
    },
    onOkClick() {
      if (this.resolve) this.resolve(true);
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.input-title {
  font-family: 'Playfair Display' !important;
}
</style>
